import { render, staticRenderFns } from "./teacherList.vue?vue&type=template&id=6b26122b&scoped=true&"
import script from "./teacherList.vue?vue&type=script&lang=js&"
export * from "./teacherList.vue?vue&type=script&lang=js&"
import style0 from "./teacherList.vue?vue&type=style&index=0&id=6b26122b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b26122b",
  null
  
)

export default component.exports